export const SERVICE_AREAS = [
  "Orleans", "Kanata", "Barrhaven", "Nepean", "Stittsville", "Downtown Ottawa", "Gatineau",
];

export const CONTACT = {
  phone: "(613) 854-6086",
  email: "experts@reverence.services",
  hours: "Mon–Sat · 8am–8pm",
};

export const HERO_IMG =
  "https://customer-assets-v7afamib.emergentagent.net/job_d0c6979d-9118-4f08-b608-19a95445ffbf/artifacts/mup0m2qe_f19acbb5-7b55-4ce6-9702-6d2b06187e20.png";

// Cinematic hero background slideshow — real Reverence Autos projects
export const HERO_SLIDES = [
  { src: HERO_IMG, pos: "center" },
  { src: "/gallery/img_7051.webp", pos: "center" },
  { src: "/gallery/img_7038.webp", pos: "center" },
  { src: "/gallery/img_6291.webp", pos: "center" },
  { src: "/gallery/img_7279.webp", pos: "center" },
];

export const GALLERY = {
  jaguar: "https://images.pexels.com/photos/163224/jaguar-oldtimer-red-auto-163224.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  car2: "https://images.pexels.com/photos/33602226/pexels-photo-33602226.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  polish: "https://images.pexels.com/photos/14908957/pexels-photo-14908957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  polishRed: "https://images.pexels.com/photos/37809565/pexels-photo-37809565.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const TIME_SLOTS = [
  { id: "morning", label: "Morning", window: "8:00 – 11:00 AM" },
  { id: "midday", label: "Midday", window: "11:00 – 2:00 PM" },
  { id: "afternoon", label: "Afternoon", window: "2:00 – 5:00 PM" },
  { id: "evening", label: "Evening", window: "5:00 – 8:00 PM" },
];
